// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.calendarCustom_XrdUs {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--_00000020-background);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 20px;
}

.calendarCustom_XrdUs .content_fkXT1 {
    max-width: 400px;
    width: 100%;
    background-color: var(--white-color);
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    font-family: inherit;
    overflow: hidden;
}

.calendarCustom_XrdUs .header_l8cxF {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 10px 20px;
    border-bottom: 1px solid var(--f0-border);
}

.calendarCustom_XrdUs button {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    transition: background-color 0.2s;
}

.calendarCustom_XrdUs button:hover {
    background-color: var(--f0-border);
}

.calendarCustom_XrdUs h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 6px;
    transition: background-color 0.2s;
}

.calendarCustom_XrdUs h2:hover {
    background-color: var(--f0-border);
}

.yearMonthPicker_oNhaE {
    padding: 20px;
    border-bottom: 1px solid var(--f0-border);
    background-color: var(--fa-background);
}

.yearMonthPicker_oNhaE label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #555;
}

.yearMonthPicker_oNhaE select {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #cbcbcb;
    font-size: 16px;
    background-color: var(--white-color);
    cursor: pointer;
}

.yearMonthPicker_oNhaE .monthGrid_SqYNN {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-top: 12px;
}

.yearMonthPicker_oNhaE .monthGrid_SqYNN button {
    padding: 12px 8px;
    border: 1px solid #e1e5e9;
    border-radius: 8px;
    background: var(--white-color);
    color: #333;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s ease;
}

.yearMonthPicker_oNhaE .monthGrid_SqYNN button:hover {
    background-color: var(--f5-background);
    border-color: var(--_10a37f-background);
}

.yearMonthPicker_oNhaE .monthGrid_SqYNN button.selected_eMRnf {
    background-color: var(--_10a37f-background);
    color: var(--white-color);
    border-color: var(--_10a37f-background);
}

.daysHeader_eYUe7 {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 2px;
    margin-bottom: 10px;
    padding: 0 20px;
}

.daysHeader_eYUe7 div {
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: var(--_6-color);
    padding: 8px 4px;
}

.calendarGrid_DE1X8 {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 2px;
    padding: 0 20px;
}

.calendarGrid_DE1X8 button {
    padding: 12px 4px;
    border: none;
    background: transparent;
    color: #333;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    position: relative;
    min-height: 40px;
}

.calendarGrid_DE1X8 button:hover {
    background-color: var(--f5-background);
}

.calendarGrid_DE1X8 button.selected_eMRnf {
    background-color: var(--_10a37f-background);
    color: var(--white-color);
}

.calendarGrid_DE1X8 button.today_KtP47 {
    background-color: #E3F2FD;
    color: #1976D2;
    font-weight: 600;
}

.calendarGrid_DE1X8 button.event_xkLXR::after {
    content: '';
    width: 6px;
    height: 6px;
    background-color: #FF4444;
    border-radius: 50%;
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
}

.calendarGrid_DE1X8 button.event_xkLXR.selected_eMRnf::after {
    background-color: var(--white-color);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Calendar/Calendar.module.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,6CAA6C;IAC7C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,oCAAoC;IACpC,mBAAmB;IACnB,0CAA0C;IAC1C,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;IAC5B,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["\n.calendarCustom {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--_00000020-background);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    padding: 20px;\n}\n\n.calendarCustom .content {\n    max-width: 400px;\n    width: 100%;\n    background-color: var(--white-color);\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    font-family: inherit;\n    overflow: hidden;\n}\n\n.calendarCustom .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 20px 10px 20px;\n    border-bottom: 1px solid var(--f0-border);\n}\n\n.calendarCustom button {\n    background: none;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n    transition: background-color 0.2s;\n}\n\n.calendarCustom button:hover {\n    background-color: var(--f0-border);\n}\n\n.calendarCustom h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n    cursor: pointer;\n    padding: 5px 10px;\n    border-radius: 6px;\n    transition: background-color 0.2s;\n}\n\n.calendarCustom h2:hover {\n    background-color: var(--f0-border);\n}\n\n.yearMonthPicker {\n    padding: 20px;\n    border-bottom: 1px solid var(--f0-border);\n    background-color: var(--fa-background);\n}\n\n.yearMonthPicker label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #555;\n}\n\n.yearMonthPicker select {\n    width: 100%;\n    padding: 12px;\n    border-radius: 8px;\n    border: 1px solid #cbcbcb;\n    font-size: 16px;\n    background-color: var(--white-color);\n    cursor: pointer;\n}\n\n.yearMonthPicker .monthGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    margin-top: 12px;\n}\n\n.yearMonthPicker .monthGrid button {\n    padding: 12px 8px;\n    border: 1px solid #e1e5e9;\n    border-radius: 8px;\n    background: var(--white-color);\n    color: #333;\n    cursor: pointer;\n    font-size: 13px;\n    transition: all 0.2s ease;\n}\n\n.yearMonthPicker .monthGrid button:hover {\n    background-color: var(--f5-background);\n    border-color: var(--_10a37f-background);\n}\n\n.yearMonthPicker .monthGrid button.selected {\n    background-color: var(--_10a37f-background);\n    color: var(--white-color);\n    border-color: var(--_10a37f-background);\n}\n\n.daysHeader {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 2px;\n    margin-bottom: 10px;\n    padding: 0 20px;\n}\n\n.daysHeader div {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--_6-color);\n    padding: 8px 4px;\n}\n\n.calendarGrid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 2px;\n    padding: 0 20px;\n}\n\n.calendarGrid button {\n    padding: 12px 4px;\n    border: none;\n    background: transparent;\n    color: #333;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    position: relative;\n    min-height: 40px;\n}\n\n.calendarGrid button:hover {\n    background-color: var(--f5-background);\n}\n\n.calendarGrid button.selected {\n    background-color: var(--_10a37f-background);\n    color: var(--white-color);\n}\n\n.calendarGrid button.today {\n    background-color: #E3F2FD;\n    color: #1976D2;\n    font-weight: 600;\n}\n\n.calendarGrid button.event::after {\n    content: '';\n    width: 6px;\n    height: 6px;\n    background-color: #FF4444;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 4px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.calendarGrid button.event.selected::after {\n    background-color: var(--white-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarCustom": `calendarCustom_XrdUs`,
	"content": `content_fkXT1`,
	"header": `header_l8cxF`,
	"yearMonthPicker": `yearMonthPicker_oNhaE`,
	"monthGrid": `monthGrid_SqYNN`,
	"selected": `selected_eMRnf`,
	"daysHeader": `daysHeader_eYUe7`,
	"calendarGrid": `calendarGrid_DE1X8`,
	"today": `today_KtP47`,
	"event": `event_xkLXR`
};
export default ___CSS_LOADER_EXPORT___;
